<template>
    <div class="slider px-3">
        <transition name="slide-transition" mode="out-in">
            <SingleSlide
                :key="currentSlideIndex"
                :current-slide-index="currentSlideIndex"
                :num-of-all-slides="slidesParsed.length"
                :header="currentSlide?.header"
                :slogan="currentSlide?.slogan"
                :button="currentSlide?.button"
                :img="currentSlide?.img"
                @changeSlide="toSlide($event)"
                @prevSlide="previousSlide"
                @nextSlide="nextSlide"
            ></SingleSlide>
        </transition>
    </div>
</template>

<script>
import {defineComponent} from "vue";
import SingleSlide from "./SingleSlide";

export default defineComponent({
    name: "Slider",
    components: { SingleSlide },
    props: {
        slides: String  //  JSON.
    },
    data(){
        return {
            currentSlideIndex: 0,
            sliderTimeoutId: null
        }
    },
    mounted(){

        this.startCounter();

    },
    beforeUnmount(){

        this.stopCounter();

    },
    methods: {
        nextSlide(){
            if(this.slidesParsed.length <= 1) return;
            if(this.currentSlideIndex < this.slidesParsed.length - 1){
                this.currentSlideIndex++;
            } else {
                this.currentSlideIndex = 0;
            }
            this.startCounter();
        },
        previousSlide(){
            if(this.slidesParsed.length <= 1) return;
            if(this.currentSlideIndex > 0){
                this.currentSlideIndex--;
            } else {
                this.currentSlideIndex = this.slidesParsed.length - 1;
            }
            this.startCounter();
        },
        toSlide(index){
            if(this.currentSlideIndex !== index){
                this.currentSlideIndex = index;
                this.startCounter();
            }
        },
        startCounter(){
            this.stopCounter();
            this.sliderTimeoutId = setTimeout(() => {
                this.nextSlide();
                this.startCounter();
            }, 5000);
        },
        stopCounter(){
            clearTimeout(this.sliderTimeoutId);
        }
    },
    computed: {
        slidesParsed(){
            return JSON.parse(this.slides) || [];
        },
        currentSlide(){
            return this.slidesParsed?.[this.currentSlideIndex] || {};
        }
    }
})
</script>

<style lang="scss" scoped>

.slider {
    margin: auto;
    width: 100%;
    max-width: 1500px;
    overflow: hidden;
}

.slide-transition-leave-active,
.slide-transition-enter-active {
    transition: all 0.5s ease-out;
}

.slide-transition-enter-from {
    transform: translateX(50px);
    opacity: 0;
}

.slide-transition-leave-to {
    transform: translateX(-50px);
    opacity: 0;
}

</style>